import React, { useEffect, useState } from "react";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import PropTypes from "prop-types";
import Breadcrumb from "../components/breadcrumb";
import Header03 from "../components/header/Header03";
import MobileHeader from "../components/header/MobileHeader";
import JobSec1 from "../components/jobs/JobSec1";
import dataJobs from "../assets/fakeData/dataJobs";
import Footer from "../components/footer";
import FormSearch from "../components/formsearch";
import Gotop from "../components/gotop";
import { Link } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Collapse } from "react-collapse";
import logo from "../assets/images/logo.png";
import httpService from "../services/httpService";

Jobs.propTypes = {};

function Jobs(props) {
  const [jobs, setJobs] = useState([]);
  const [jobsArchived, setJobsArchived] = useState([]);
  const [searchWord, setSearchWord] = useState("");
  const [pageLoading, setPageLoading] = useState(true);
  const [toggle, setToggle] = useState({
    key: "",
    status: false,
  });
  const [isShowMobile, setShowMobile] = useState(false);

  const handleToggle = (key) => {
    if (toggle.key === key) {
      setToggle({
        status: false,
      });
    } else {
      setToggle({
        status: true,
        key,
      });
    }
  };

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  const getJobs = async () => {
    try {
      const res = await httpService.get(`jobs`);
      setJobs(res.data.data);
      setJobsArchived(res.data.data);
      setPageLoading(false);
    } catch (error) {
      setPageLoading(false);
      alert("An error occurred while trying to get sponsorship jobs, please reload and try again")
    }
  };

  useEffect(() => {
    getJobs();
  }, []);

  const handleSearch = async () => {
    try {
      setPageLoading(true);
      const res = await httpService.get(`jobs/search?title=${searchWord}`);
      setJobs(res.data.data.jobs);
      setPageLoading(false);
    } catch (error) {
      setPageLoading(false);
      alert("An error occurred while trying to search for the sponsorship job, please reload and try again")
    }
  };

  const resetJobList = () => {
    setJobs(jobsArchived);
    setSearchWord("");
  };

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>UKICNEWS - UK Latest Sponsorship Jobs</title>
          <meta
            name="description"
            content="Find the latest UK sponsorship jobs for work visas. Explore opportunities for skilled workers, healthcare professionals, and more."
          />
          <link rel="canonical" href="https://www.ukicnews.com/jobs" />

          {/* Open Graph (Facebook / LinkedIn preview) */}
          <meta property="og:type" content="website" />
          <meta property="og:title" content={`UKICNEWS | Latest Sponsorship Jobs`} />
          <meta
            property="og:description"
            content="Find the latest UK sponsorship jobs for work visas. Explore opportunities for skilled workers, healthcare professionals, and more."
          />
          <meta property="og:url" content="https://www.ukicnews.com/jobs" />
          <meta property="og:image" content="https://www.ukicnews.com/preview.png" />

          {/* Twitter preview */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={`UKICNEWS | Latest Sponsorship Jobs`} />
          <meta
            name="twitter:description"
            content="Find the latest UK sponsorship jobs for work visas. Explore opportunities for skilled workers, healthcare professionals, and more."
          />
          <meta name="twitter:image" content="https://www.ukicnews.com/preview.png" />
        </Helmet>
      </HelmetProvider>
      <MobileHeader handleMobile={handleMobile} />
      <Header03 clname="actJob1" handleMobile={handleMobile} />
      <FormSearch searchWord={searchWord} setSearchWord={setSearchWord} handleSearch={handleSearch} resetJobList={resetJobList} />
      <JobSec1 data={jobs} pageLoading={pageLoading} />
      <Footer />
      <Gotop />
    </>
  );
}

export default Jobs;
